import { render, staticRenderFns } from "./LoaderKel.vue?vue&type=template&id=72c4b9be&scoped=true"
import script from "./LoaderKel.vue?vue&type=script&lang=js"
export * from "./LoaderKel.vue?vue&type=script&lang=js"
import style0 from "./LoaderKel.vue?vue&type=style&index=0&id=72c4b9be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c4b9be",
  null
  
)

export default component.exports